import { Suspense, useMemo } from 'react';
import { Banners } from './variations/banners-with-external-link';
import { BannersWithVideoAndExternalLink } from './variations/banners-with-video-and-external-link';
import { InjectedCurrentPage } from './variations/injected-current-page';

import Loading from '@ingka/loading';
import {
  ContentPageSectionVisibility,
  PlannerConfigEntityPhraseStrings,
} from '@/services/configurator/PlannerConfigTypes';
import { Alert, AlertTitle } from '@/components/ui/alert';
import { ArrowBigDown } from 'lucide-react';
import { ContentPageVariant } from '@pnpmworkspace/shared-types';

type PlannerContentPagePreviewProps = {
  headerVisible: boolean;
  dynamicView?: ContentPageSectionVisibility;
  showInPages?: string[];
  plannerUrl?: string;
  imageUrl?: string;
  phraseStrings?: PlannerConfigEntityPhraseStrings;
  secondaryBannerImgUrl?: string;
  contentPageVariant?: ContentPageVariant;
  videoUrl?: string;
};

export const PlannerContentPagePreview = (
  props: PlannerContentPagePreviewProps,
) => {
  const {
    headerVisible,
    dynamicView,
    contentPageVariant,
    imageUrl,
    phraseStrings,
    plannerUrl,
    secondaryBannerImgUrl,
    videoUrl,
  } = props;
  const component = useMemo(() => {
    switch (contentPageVariant) {
      case 'inject_current_page': {
        return <InjectedCurrentPage phraseStrings={phraseStrings} />;
      }
      case 'banners_with_external_link': {
        return (
          <Banners
            dynamicView={dynamicView}
            contentPageVariant={contentPageVariant}
            imageUrl={imageUrl}
            phraseStrings={phraseStrings}
            plannerUrl={plannerUrl}
            secondaryBannerImgUrl={secondaryBannerImgUrl}
          />
        );
      }
      case 'banners_with_video_and_external_link': {
        return (
          <BannersWithVideoAndExternalLink
            contentPageVariant={contentPageVariant}
            imageUrl={imageUrl}
            phraseStrings={phraseStrings}
            plannerUrl={plannerUrl}
            secondaryBannerImgUrl={secondaryBannerImgUrl}
            dynamicView={dynamicView}
            videoUrl={videoUrl}
          />
        );
      }
      default: {
        console.log(`No components matched ${contentPageVariant}.`);
      }
    }
  }, [contentPageVariant, props, dynamicView]);
  return (
    <>
      <Suspense
        fallback={
          <div className='plann-loading-indicator flex justify-center items-center h-screen'>
            <Loading />
          </div>
        }
      >
        {headerVisible && (
          <Alert className='mb-4 border-slate-800 bg-slate-800  text-white'>
            <ArrowBigDown className='h-4 w-4' />
            <AlertTitle className='font-bold'>Content page</AlertTitle>
          </Alert>
        )}
        {component}
      </Suspense>
    </>
  );
};
